<template>
    <section class="container mx-auto py-12 px-4">
        <!-- Dynamic Page Title -->
        <div class="text-center mb-12">
            <h2 class="text-4xl font-bold text-green-900 mb-4">{{ committeeName }}</h2>
            <p class="text-lg text-gray-600">
                Meet the esteemed members of our {{ committeeName }} who guide and lead our club with dedication and
                expertise.
            </p>
        </div>

        <!-- Dynamic Sections -->
        <div v-for="(members, role) in councilMembers" :key="role" class="mb-12">
            <h3 class="text-2xl font-bold text-green-900 mb-6">{{ role }}</h3>
            <div
                :class="role === 'Chief Advisor' ? 'flex justify-center' : 'grid grid-cols-1 md:grid-cols-4 gap-6 justify-center'">
                <div v-for="member in members" :key="member.id"
                    class="bg-white text-black p-6 rounded-lg shadow-lg border text-center">
                    <img :src="`${this.$root.$data.BASE_URL}/members/images/${member.profile_pic}`" alt="Member Image"
                        class="w-32 h-32 mx-auto rounded-full mb-4 object-cover" />
                    <h3 class="text-xl font-bold">{{ member.name }}</h3>
                    <p class="text-sm mb-4">{{ role }}</p>
                    <router-link :to="{ path: `/member/${member.member_code}` }"
                        class="bg-white text-green-900 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100">
                        Show Details
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "CouncilPage",
    data() {
        return {
            committeeName: "", // Holds the name of the committee
            councilMembers: {}, // Stores members grouped by roles
        };
    },
    watch: {
        $route(to, from) {
            if (to.params.slug !== from.params.slug) {
                this.fetchCouncilMembers(); // Fetch new data when route changes
            }
        },
    },
    created() {
        this.fetchCouncilMembers();
    },
    methods: {
        async fetchCouncilMembers() {
            try {
                const slug = this.$route.params.slug; // Get slug from the route
                const response = await axios.get(
                    `${this.$root.$data.BASE_URL}/api/comittee/${slug}/members`
                );
                this.committeeName = response.data.committeeName; // Set the committee name
                this.councilMembers = response.data.members; // Set members grouped by roles
            } catch (error) {
                console.error("Error fetching council members:", error);
            }
        },
    },
};
</script>

<style scoped></style>